import React, { useState } from "react";
import "./App.css";
import Portal from "./Portal/Portal";

function App() {
  return <Portal />;
}

export default App;
